<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/landing-pages'">Promotion links</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add promotion link</span>
      } @else {
        <span class="fs-5 fw-bold mb-0">Edit promotion link</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3">

          <div class="col-3">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>

          <div class="col-3">
            <label class="form-label">Type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="pageType" class="form-select" formControlName="typeId">
                <option [ngValue]="null" disabled>Select type</option>
                @for (pageType of pageTypes; track pageType.id) {
                  <option [ngValue]="pageType.id">{{ pageType }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-3">
            <label class="form-label">Site</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="pool" class="form-select" formControlName="siteId">
                <option [ngValue]="null">No site</option>
                @for (site of sites; track site.id) {
                  <option [ngValue]="site.id">{{ site.name }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-3">
            <label class="form-label">Offer</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <app-dropdown-select [multiple]="true" formControlName="offers">
                @for (offer of offers; track offer.id) {
                  <app-dropdown-select-option [value]="offer.id">{{ offer }}</app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              @for (variable of variables; track $index) {
                <span (click)="insertVariable(variable)" class="badge bg-primary me-2" role="button" title="Plain text parameter {{ variable }}">
                  <i class="bi bi-shield-lock"></i> {{ variable }}
                </span>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              @for (variable of variables; track $index) {
                <span (click)="insertEncryptedVariable(variable)" class="badge bg-success me-2"
                role="button" title="Encrypted parameter {{ variable }}"><i class="bi bi-shield-lock-fill"></i> {{ variable }}</span>
              }
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label class="form-label">URL</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-globe"></i></span>
                <input type="text" class="form-control" placeholder="https://www.url.com/landing" formControlName="url">
                @if (getUrl()) {
                  <a class="btn btn-primary fw-bold" [href]="getUrl()" target="_blank">
                    Open Link
                  </a>
                }
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-4">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="external" formControlName="external">
                <label class="form-check-label" for="external">External</label>
              </div>
            </div>

            <div class="col-4">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="enabled" formControlName="enabled">
                <label class="form-check-label" for="enabled">Enabled</label>
              </div>
            </div>
          </div>

          <div class="text-end">
            <button type="submit" class="btn btn-primary fw-bold">
              @if (isCreate()) {
                Create
              } @else {
                Update
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
